import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import { isShopYourStoreFilterEnabledSelector } from 'viewModel/selectors/shopYourStore/isShopYourStoreFilterEnabledSelector';

const fields = createSelector(
    (_state, ownProps) => ownProps.showCompactPills,
    (_state, ownProps) => ownProps.forceCompactPills,
    isShopYourStoreFilterEnabledSelector,
    (showCompactPills, forceCompactPills, isShopYourStoreFilterEnabled) => {
        return {
            showSingleFilterPill: forceCompactPills || isShopYourStoreFilterEnabled,
            showCompactPills: forceCompactPills || (showCompactPills && isShopYourStoreFilterEnabled)
        };
    }
);

const withFilterPillsProps = wrapHOC(connect(fields));

export {
    fields, withFilterPillsProps
};
